import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import { EditTwoTone, DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'

const MitraList = ({
  data, isLoading, handleDelete,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      render: text => text || '',
    },
    {
      title: 'Website',
      dataIndex: 'website',
      key: 'website',
      render: text => text || '-',
    },
    {
      title: 'Link Registrasi',
      dataIndex: 'registration_url',
      key: 'registration_url',
      render: text => text || '-',
    },
    {
      title: 'No Telepon',
      dataIndex: 'contact_number',
      key: 'contact_number',
      render: text => text || '-',
    },
    {
      title: 'URL Panduan',
      dataIndex: 'guide_url',
      key: 'guide_url',
      render: text => text || '-',
    },
    {
      title: 'Branding',
      dataIndex: 'brand',
      key: 'brand',
      render: text => text || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditTwoTone twoToneColor="#faad14" onClick={() => history.push(`/mitra/${record.id}/edit`)} className="mr-2" />
          <Popconfirm
            title="Are you sure delete this Partner?"
            okText="Yes"
            cancelText="No"
            placement="topLeft"
            onConfirm={() => handleDelete(record.id)}
          >
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Popconfirm>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">List Mitra</h3>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => history.push('/mitra/add')}>
            Add Mitra
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={false}
      />
    </div>
  )
}

MitraList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
}

export default MitraList
